// helpers to export final execution report as JSON

export function buildReport(state) {
  const totalDurationMs = state.completedAt
    ? new Date(state.completedAt) - new Date(state.startedAt)
    : 0;
  return {
    workflowId: state.workflowId,
    workflowName: state.workflowName,
    startedAt: state.startedAt,
    completedAt: state.completedAt,
    totalDurationMs,
    stageHistory: state.history,
  };
}

export function downloadReport(state) {
  const report = buildReport(state);
  const blob = new Blob([JSON.stringify(report, null, 2)], {
    type: "application/json",
  });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `${state.workflowName.replace(/\s+/g, "_") || "workflow"}_report.json"`;
  a.click();
}
